import { BooleanPrimitiveParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';

export default (val?: boolean): BooleanPrimitiveParameterValue => ({
  type: PARAMETER_VALUE_TYPE.BOOLEAN_PRIMITIVE,
  value: val === true ? true : false,
});
